export default __webpack_public_path__ + "static/media/woman.7b396e8d.png";